// extracted by mini-css-extract-plugin
module.exports = {"container":"dece2e673c--container--eZetI","empty_photo":"dece2e673c--empty_photo--YLUeO","overlay":"dece2e673c--overlay--UmZtF","text":"dece2e673c--text--ORma0"};